<template>
  <v-navigation-drawer
    expand-on-hover
    app
    color="manuBackground"
    width="230"
    :mini-variant.sync="mini"
    floating
  >
    <v-list class="custom-list">
      <img title="go to home" style="cursor:pointer;" @click="gotoHome()" :src="!mini ? '/assets/trigma-logo.svg' : '/assets/logo-mini.svg'" alt="logo" class="mt-5 anim" :class="{'ml-2': mini, 'ml-4': !mini}" height="32" />
      <div class="mt-8">
          <v-list-item
            v-for="app in apps"
            :key="app.app_id"
            @click="goTo(app.app_url_withkey)"
            class="mb-3 d-flex align-items-center anim"
            :class="{'pl-4': mini, 'pl-6': !mini}"
            :ripple="false"
          >
            <v-list-item-icon class="mr-1 mt-3">
              <Icon :name="app.app_name.split(' ').join('-').toLowerCase()" />
            </v-list-item-icon>

            <v-list-item-title
              class="titleText--text text-left ml-4 mt-2 font-weight-bold"
              :class="{'menuActive--text': (app.app_name === 'Client Admin')}"
              >{{ app.app_name }}</v-list-item-title
            >
          </v-list-item>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import Icon from "./Icon.vue";
import API from "../apis/apifactory"

import globalval from '../global/globalvar'
export default {
  components: {
    Icon,
  },
  data () {
    return {
      apps: [],
      mini: true,
    }
  },
  methods: {
    gotoHome(){
            let newurl=globalval.PARAM_GLOBAL_HOME + localStorage.getItem("SET_USERID");
            window.location.href = newurl;
        },
    goTo(url) {
      return location.href = url
    },
    getCurrentUserApps() {
      API.getloginuserapps(this.userId).then(res => this.apps = [...res.data]).catch(error => console.warn(error))
    },
  },
  computed: {
    userId() {
      return localStorage.getItem("SET_USERID");
    },
  },
  mounted() {
    this.getCurrentUserApps()
  },
};
</script>

<style>
.selectedtab {
  border-left-width: 5px !important;
  border-left-color: #51a7f8 !important;
  border-left-style: solid !important;
  position: relative !important;
}

.custom-list .v-list-item {
  height: 26px !important;
}

.anim {
  -webkit-transition: all .3s ease-in-out;
  -moz-transition:    all .3s ease-in-out;
  -o-transition:      all .3s ease-in-out;
  -ms-transition:     all .3s ease-in-out;
  transition:         all .3s ease-in-out;
}
</style>
